import { BasicSoundBank, SoundBankLoader, } from "spessasynth_core";
function getKeyRange(zone, fallbackMin, fallbackMax) {
    if (zone.hasKeyRange)
        return {
            min: zone.keyRange.min,
            max: zone.keyRange.max,
        };
    return { min: fallbackMin, max: fallbackMax };
}
export class SoundFont {
    data;
    parsed;
    constructor(data, parsed) {
        this.data = data;
        this.parsed = parsed;
    }
    getDrumKitPresets() {
        const drumKitPresets = new Map(); // programNumber -> PresetMeta
        for (const preset of this.parsed.presets) {
            // Only drums
            if (!preset.isDrum) {
                continue;
            }
            const programNumber = preset.program;
            let presetMeta = drumKitPresets.get(programNumber);
            if (!presetMeta) {
                presetMeta = {
                    name: preset.name,
                    samples: new Map(),
                };
                drumKitPresets.set(programNumber, presetMeta);
            }
            for (const presetZone of preset.zones) {
                const presetRange = getKeyRange(presetZone, 0, 127);
                const instrument = presetZone.instrument;
                for (const instrumentZone of instrument.zones) {
                    const instRange = getKeyRange(instrumentZone, presetRange.min, presetRange.max);
                    const min = Math.max(presetRange.min, instRange.min);
                    const max = Math.min(presetRange.max, instRange.max);
                    // Sanity check
                    if (min > max)
                        continue;
                    const sampleName = instrumentZone.sample.name;
                    for (let key = min; key <= max; key++) {
                        if (!presetMeta.samples.has(key))
                            presetMeta.samples.set(key, []);
                        presetMeta.samples.get(key).push({ name: sampleName });
                    }
                }
            }
        }
        return drumKitPresets;
    }
    static async loadFromURL(url) {
        const response = await fetch(url);
        const data = await response.arrayBuffer();
        return await SoundFont.load(data);
    }
    static async load(data) {
        await BasicSoundBank.isSF3DecoderReady;
        const parsed = SoundBankLoader.fromArrayBuffer(data);
        return new SoundFont(data, parsed);
    }
}
//# sourceMappingURL=SoundFont.js.map